// removed by extract-text-webpack-plugin
module.exports = {"spacer":"CoreLayout__spacer___3WJhZ"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/CoreLayout/CoreLayout.scss
// module id = 1204
// module chunks = 1